import HeaderLinks from './header-links'
import { Link } from 'react-router'
import { APP_TITLE } from 'core/constants'
import { useTranslation } from 'react-i18next'
import StoreSelect from './store-select'
import { VpLogoDecathlonCoreSymbolBrandAsset } from '@vtmn-play/assets/react'

const HeaderComponent = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation()
  return (
    <header>
      <nav className="mg-header" aria-label="Navbar with icons">
        <div className="mg-header-left-navigation">
          <button
            type="button"
            data-testid="mg-button-header-trigger-menu"
            onClick={() => setIsOpen(!isOpen)}
            className="mg-button-header__icon"
          >
            <span className="material-icons-outlined" id="trigger-menu">
              menu
            </span>
          </button>

          <div className="mg-header-brand">
            <Link to="/" onClick={() => setIsOpen(false)}>
              <VpLogoDecathlonCoreSymbolBrandAsset />
              <span className="mg-header-title vp-title-s">{t(APP_TITLE)}</span>
            </Link>
          </div>
        </div>

        <div className="mg-header-right-navigation">
          <StoreSelect />
          <HeaderLinks />
        </div>
      </nav>
    </header>
  )
}

export default HeaderComponent
